import React from "react";
import ChartComponent, { Chart } from "react-chartjs-2";
import { lineChartOptions } from "./config";

// Overlapping Bar Chart: Both bars at same x position, both start from 0
// The smaller bar always renders on top to ensure visibility
export default class ComboChart extends React.Component {
  render() {
    const { data } = this.props;
    // console.log("data: ", data);

    // Create overlapping datasets - both at same x position
    const overlappingDatasets = [];

    if (data.datasets && data.datasets.length >= 2) {
      const revenueDataset = data.datasets[0];
      const expenseDataset = data.datasets[1];

      // Get raw data
      const revenueData = revenueDataset.data || [];
      const expenseData = expenseDataset.data || [];

      // Determine which bar should be behind based on which is generally larger
      // The LARGER bar should be behind (order: 2), SMALLER bar on top (order: 1)
      const totalRevenue = revenueData.reduce((a, b) => a + (b || 0), 0);
      const totalExpense = expenseData.reduce((a, b) => a + (b || 0), 0);

      // If total expense > total revenue, revenue is generally smaller -> should be on top
      const revenueOrder = totalExpense > totalRevenue ? 1 : 2;
      const expenseOrder = totalExpense > totalRevenue ? 2 : 1;

      // Revenue (blue)
      overlappingDatasets.push({
        ...revenueDataset,
        type: "bar",
        label: revenueDataset.label || "Doanh thu",
        backgroundColor: "rgba(84, 141, 221, 0.9)",
        borderColor: "rgba(84, 141, 221, 1)",
        borderWidth: 0,
        hoverBackgroundColor: "rgba(84, 141, 221, 1)",
        barPercentage: 0.7,
        categoryPercentage: 1.0,
        order: revenueOrder,
      });

      // Expense (orange)
      overlappingDatasets.push({
        ...expenseDataset,
        type: "bar",
        label: expenseDataset.label || "Chi phí",
        backgroundColor: "rgba(245, 166, 35, 0.95)",
        borderColor: "rgba(245, 166, 35, 1)",
        borderWidth: 0,
        hoverBackgroundColor: "rgba(245, 166, 35, 1)",
        barPercentage: 0.7,
        categoryPercentage: 1.0,
        order: expenseOrder,
      });
    }

    const comboData = {
      ...data,
      datasets: overlappingDatasets,
    };

    const comboOptions = {
      ...lineChartOptions,
      scales: {
        ...lineChartOptions.scales,
        xAxes: [
          {
            stacked: true, // Stacked on X = same position
            gridLines: {
              display: false,
            },
            ticks: {
              fontColor: "#666",
            },
          },
        ],
        yAxes: [
          {
            stacked: false, // NOT stacked on Y = both start from 0
            gridLines: {
              display: true,
              lineWidth: 1,
              color: "rgba(0,0,0,0.08)",
              drawBorder: false,
            },
            ticks: {
              beginAtZero: true,
              padding: 15,
              fontColor: "#666",
              callback: function (value) {
                if (value >= 1000000) {
                  return (value / 1000000).toFixed(1) + "M";
                } else if (value >= 1000) {
                  return (value / 1000).toFixed(0) + "K";
                }
                return value.toLocaleString();
              },
            },
          },
        ],
      },
      tooltips: {
        ...lineChartOptions.tooltips,
        mode: "index",
        intersect: false,
        callbacks: {
          label: function (tooltipItem, chartData) {
            const label =
              chartData.datasets[tooltipItem.datasetIndex].label || "";
            const value = tooltipItem.yLabel.toLocaleString();
            return `${label}: ${value} đ`;
          },
        },
      },
      hover: {
        mode: "index",
        intersect: false,
      },
      legend: {
        display: true,
        position: "top",
        align: "end",
        labels: {
          usePointStyle: true,
          padding: 15,
          fontColor: "#666",
          boxWidth: 12,
        },
      },
    };

    return (
      <ChartComponent
        ref={(ref) => (this.chart_instance = ref && ref.chart_instance)}
        type="bar"
        options={comboOptions}
        data={comboData}
      />
    );
  }
}
